import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import { sumTotal } from '../../../../../react-table/helpers/rowTotals';

export function getDetailsTabNavigationProps(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.RESCON_CONSIGNMENT_ID_NOT_IN_PRECON_DETAILS.id,
    mainReportId: ReportDefinitions.RESCON_CONSIGNMENT_ID_NOT_IN_PRECON_SUMMARY.id,
    requestParams: {
      senderId: rowInfo.row['resconSender'], // eslint-disable-line
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    TextColumn,
    NavigationColumn,
    NonZeroNumberColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Sender', 'sender'),
        new TextColumn('Sending mailbox', 'resconSender')
          .withTotalHeader('Total'),
        new NavigationColumn(new NonZeroNumberColumn('Consignments', 'consignments')
          .withTotalHeader(sumTotal), getDetailsTabNavigationProps),
      ],
    },
    {
      Header: 'RESCON consignment ID',
      columns: [
        new NavigationColumn(new NonZeroNumberColumn('Missing', 'resconConsignmentId.missing')
          .withTotalHeader(sumTotal), getDetailsTabNavigationProps),
        new NavigationColumn(new NonZeroNumberColumn('Starts with own country code', 'resconConsignmentId.startsWithOwnCountryCode')
          .withTotalHeader(sumTotal), getDetailsTabNavigationProps),
      ],
    },
  ];
};
